import * as React from 'react';
import styles from './index.less';
import { FServiceAPI, FUtil, FI18n } from '@freelog/tools-lib';
import { connect } from 'dva';
import { ActivityDetailsPageModelState, ConnectState, UserModelState } from '@/models/connect';
import * as AHooks from 'ahooks';
import { Outlet, useMatch, Dispatch } from 'umi';
import FSimpleBar from '@/components/FSimpleBar';
import SimpleBar from 'simplebar';
import FHeaderNavigation from '@/components/FHeaderNavigation';
import { FetchInfoAction } from '@/models/user';

interface FBaseLayoutProps {
  dispatch: Dispatch;
  user: UserModelState;
  activityDetailsPage: ActivityDetailsPageModelState;
}

interface FBaseLayoutStates {
  activeIDs: [string, string];
}

const initStates: FBaseLayoutStates = {
  activeIDs: ['', ''],
};

function useNarrowScreen() {
  const [narrow, setNarrow] = React.useState(
    () => typeof window !== 'undefined' && window.innerWidth < 1100,
  );
  React.useEffect(() => {
    const mql = window.matchMedia('(max-width: 1099px)');
    const apply = () => setNarrow(mql.matches);
    apply();
    mql.addEventListener('change', apply);
    return () => mql.removeEventListener('change', apply);
  }, []);
  return narrow;
}

function FBaseLayout({ dispatch, user, activityDetailsPage }: FBaseLayoutProps) {
  const match_home = useMatch('/home');
  const match_activities = useMatch('/activities');
  const ref_SimpleBar = React.useRef<SimpleBar>(null);
  const [$activeIDs, set$activeIDs] = React.useState<FBaseLayoutStates['activeIDs']>(
    initStates['activeIDs'],
  );
  const isNarrow = useNarrowScreen();
  const hideHeader = activityDetailsPage.showActivity === 'PaymentSubsidy' && isNarrow;

  AHooks.useUnmount(() => {});

  React.useEffect(() => {
    if (match_home) {
      set$activeIDs(['product', '']);
      ref_SimpleBar?.current?.getScrollElement()?.scrollTo({ top: 0, behavior: 'instant' });
    } else if (match_activities) {
      set$activeIDs(['activities', '']);
      ref_SimpleBar?.current?.getScrollElement()?.scrollTo({ top: 0, behavior: 'instant' });
    } else {
      set$activeIDs(initStates['activeIDs']);
      ref_SimpleBar?.current?.getScrollElement()?.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [match_home, match_activities]);

  return (
    <div className={[styles.Layout, hideHeader ? styles.layoutNoHeader : ''].join(' ')}>
      {!hideHeader && (
      <div className={styles.Header}>
        <FHeaderNavigation
          logoBtn={{ href: FUtil.LinkTo.home() }}
          // showAlphaTest={true}
          // showConsoleBabel={true}
          menu={[
            {
              id: 'product',
              text: FI18n.i18nNext.t('nav_product'),
              href: FUtil.LinkTo.home(),
              items: [],
            },
            {
              id: 'discover',
              // text: '发现',
              text: FI18n.i18nNext.t('nav_explore'),
              href: FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.market(),
              items: [
                {
                  id: 'myResource',
                  // text: '发现资源',
                  text: FI18n.i18nNext.t('nav_explore_resourcemarket'),
                  href: FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.market(),
                },
                {
                  id: 'myCollection',
                  // text: '示例节点',
                  text: FI18n.i18nNext.t('nav_explore_nodes'),
                  href: FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.market(),
                },
              ],
            },
            {
              id: 'activities',
              // text: '活动',
              text: FI18n.i18nNext.t('nav_events'),
              href: FUtil.LinkTo.activities(),
              items: [],
            },
            {
              id: 'community',
              text: FI18n.i18nNext.t('nav_communitiy'),
              // href: 'https://forum.freelog.com/',
              href: FI18n.i18nNext.t('nav_communitiy_link'),
              target: '_blank',
              items: [],
            },
            {
              id: 'help',
              text: FI18n.i18nNext.t('nav_docs'),
              // href: 'https://freelog3.freelog.com/',
              href: FI18n.i18nNext.t('nav_docs_link'),
              target: '_blank',
              items: [],
            },
          ]}
          activeIDs={$activeIDs}
          showGotoConsole={!!user.userInfo}
          userPanel={
            user.userInfo
              ? {
                  info: {
                    // avatar: userInfo.headImage,
                    avatar: FUtil.Tool.getAvatarUrl(),
                    userName: user.userInfo.username,
                    email: user.userInfo.email,
                    phone: user.userInfo.mobile,
                  },
                  menu: [
                    {
                      // text: '个人中心',
                      text: FI18n.i18nNext.t('nav_UserProfile'),
                      onClick() {
                        window.open(
                          FUtil.Format.completeUrlByDomain('user'),
                        );
                      },
                    },
                    {
                      // text: '登出',
                      text: FI18n.i18nNext.t('nav_logout'),
                      async onClick() {
                        await FServiceAPI.User.logout();
                        // dispatch<FetchInfoAction>({
                        //   type: 'user/fetchInfo',
                        // });
                        self.location.reload();
                      },
                    },
                  ],
                }
              : null
          }
          showHotspotTooltip
        />
      </div>
      )}
      <FSimpleBar
        id={'layout-content'}
        height={hideHeader ? '100vh' : 'calc(100vh - 70px)'}
        onMount={(simpleBar) => {
          // @ts-ignore
          ref_SimpleBar.current = simpleBar;
        }}
      >
        <div
          style={{
            width: hideHeader ? '100%' : '100vw',
            // overflowX: 'hidden'
          }}
        >
          <Outlet />
        </div>
      </FSimpleBar>
    </div>
  );
}

export default connect(
  ({
    // global,
    user,
    activityDetailsPage,
  }: ConnectState) => ({
    // global,
    user,
    activityDetailsPage,
  }),
)(FBaseLayout);

// export default FBaseLayout;
